import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "bootstrap/dist/css/bootstrap.css";
import "@/assets/css/base.css"
// import "@/assets/css/animate.css"
import "@/assets/css/global.scss"
import "@/fonts/font.css"
import "bootstrap"
import 'element-ui/lib/theme-chalk/index.css';
import { Input, Select, Option, Pagination } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(Element, {
//   // size: Cookies.get('size') || 'medium' // set element-ui default size
// })

// 引入elementUI
import { Message  } from 'element-ui';
//由于Message组件并没有install 方法供Vue来操作的，是直接返回的，因此按照官方文档单独引入的方法是
//会报错的，需要给 Message 添加 install 方法
Message.install = function (Vue, options) {
  Vue.prototype.$message = Message
}
Vue.use(Message )//消息提示
Vue.use(Input )
Vue.use(Select )
Vue.use(Option )
Vue.use(Pagination )
Vue.config.productionTip = false

router.afterEach(() => {
  window.scrollTo(0,0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
